<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {doShow as showAlert} from '../../#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import sendIcon from '@iconify/icons-fa-solid/envelope'
    import walletIcon from '@iconify/icons-fa-solid/wallet'
    import {
        getFairLeaderboard,
        getReferralLeaderboard,
        getLeaderboardByWeek,
        getLeaderboardByMonth,
        sendUserMessage
    } from 'src/components/cabinet/#services/kitsuneBot'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'

    let messageModalOpen = false
    let selectedClientId
    let currentPageFair = 0
    let currentPageRef = 0
    let currentPageWeek = 0
    let currentPageMonth = 0
    let perPageFair = 15
    let perPageRef = 15
    let perPageWeek = 15
    let perPageMonth = 15
    let maxButtons = 5
    let message

    function filterFair() {
        getFairLeaderboard.reset()
        getFairLeaderboard.send({data:{ page: currentPageFair + 1, perPage: perPageFair }})
    }

    function filterRef() {
        getReferralLeaderboard.reset()
        getReferralLeaderboard.send({data:{ page: currentPageRef + 1, perPage: perPageRef }})
    }

    function filterWeek() {
        getLeaderboardByWeek.reset()
        getLeaderboardByWeek.send({data:{ page: currentPageWeek + 1, perPage: perPageWeek }})
    }

    function filterMonth() {
        getLeaderboardByMonth.reset()
        getLeaderboardByMonth.send({data:{ page: currentPageMonth + 1, perPage: perPageMonth }})
    }

    async function sendMessage() {
        if (message !== '') {
            try {
                await sendUserMessage.request({data: {clientId: selectedClientId, message}})

                messageModalOpen = false

                showAlert.set({
                    status: 'success',
                    text: 'Message successfully sent!'
                })
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            }
        }
    }

    $:currentPageFair,perPageFair,filterFair()
    $:currentPageRef,perPageRef,filterRef()
    $:currentPageWeek,perPageWeek,filterWeek()
    $:currentPageMonth,perPageMonth,filterMonth()
</script>

<svelte:head>
    <title>Leaderboard</title>
</svelte:head>

<MainLayout title="Leaderboard">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="k-tasks" class="btn btn-primary mb-3">Back</Link>
                <div class="row">
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Fair tournament</p>
                            {#if $getFairLeaderboard.hasValue}
                                <PerPage
                                    bind:perPage={perPageFair}
                                    disabled={$getFairLeaderboard.loading || $getFairLeaderboard.loading}
                                    totalCount={$getFairLeaderboard.value.totalCount}
                                />
                            {/if}
                            <Table bordered responsive>
                                <thead>
                                <tr>
                                    <td class="text-center">Place</td>
                                    <td class="text-center">User</td>
                                    <td class="text-center">Stats</td>
                                    <td class="text-center">Points</td>
                                </tr>
                                </thead>
                                <tbody>
                                {#if !$getFairLeaderboard.hasValue && $getFairLeaderboard.loading}
                                    <tr>
                                        <td class="text-center" colSpan="4">Loading...</td>
                                    </tr>
                                {:else if !$getFairLeaderboard.hasValue && $getFairLeaderboard.error }
                                    <tr>
                                        <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
                                    </tr>
                                {:else if $getFairLeaderboard.value}
                                    {#each $getFairLeaderboard.value.data as {clientId, address, totalAward, firstName, lastName, userName, stats}, i}
                                        <tr class:top-20={currentPageFair * perPageFair + i + 1 <= 10}>
                                            <td class="text-center">{currentPageFair * perPageFair + i + 1}</td>
                                            <td class="user-column">
                                                <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                    {#if userName}
                                                        @{userName}
                                                    {:else}
                                                        {firstName}{lastName ? ' '+lastName : ''}
                                                    {/if}
                                                </a>
                                                <a href="https://tonviewer.com/{address}" class="realis-logo send-btn" target="_blank" title="Wallet address">
                                                    <IconifyIcon icon={walletIcon}/>
                                                </a>
                                                <button on:click={() => {
                                                    selectedClientId = clientId
                                                    messageModalOpen = true
                                                }} class="btn send-btn" title="Send Message">
                                                    <IconifyIcon icon={sendIcon}/>
                                                </button>
                                            </td>
                                            <td title="Completed / Approved / Rejected">
                                                <span class="orange">{stats?.done}</span> /
                                                <span class="green">{stats?.approved}</span> /
                                                <span class="red">{stats?.rejected}</span>
                                            </td>
                                            <td class="text-center">{totalAward}</td>
                                        </tr>
                                    {/each}
                                {/if}
                                </tbody>
                            </Table>
                            {#if $getFairLeaderboard.hasValue}
                                <Pagination
                                    bind:currentPage={currentPageFair}
                                    totalCount={$getFairLeaderboard.value.totalCount}
                                    perPage={perPageFair}
                                    {maxButtons}
                                    disabled={$getFairLeaderboard.loading || $getFairLeaderboard.loading}
                                />
                            {/if}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Referral leaderboard</p>
                            {#if $getReferralLeaderboard.hasValue}
                                <PerPage
                                    bind:perPage={perPageRef}
                                    disabled={$getReferralLeaderboard.loading || $getReferralLeaderboard.loading}
                                    totalCount={$getReferralLeaderboard.value.totalCount}
                                />
                            {/if}
                            <Table bordered responsive>
                                <thead>
                                <tr>
                                    <td class="text-center">Place</td>
                                    <td class="text-center">User</td>
                                    <td class="text-center">Referrals</td>
                                </tr>
                                </thead>
                                <tbody>
                                {#if !$getReferralLeaderboard.hasValue && $getReferralLeaderboard.loading}
                                    <tr>
                                        <td class="text-center" colSpan="3">Loading...</td>
                                    </tr>
                                {:else if !$getReferralLeaderboard.hasValue && $getReferralLeaderboard.error }
                                    <tr>
                                        <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                                    </tr>
                                {:else if $getReferralLeaderboard.value}
                                    {#each $getReferralLeaderboard.value.data as {clientId, address, totalRef, firstName, lastName, userName}, i}
                                        <tr class:top-20={currentPageRef * perPageRef + i + 1 <= 10}>
                                            <td class="text-center">{currentPageRef * perPageRef + i + 1}</td>
                                            <td class="user-column">
                                                <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                    {#if userName}
                                                        @{userName}
                                                    {:else}
                                                        {firstName}{lastName ? ' '+lastName : ''}
                                                    {/if}
                                                </a>
                                                <a href="https://tonviewer.com/{address}" class="realis-logo send-btn" target="_blank" title="Wallet address">
                                                    <IconifyIcon icon={walletIcon}/>
                                                </a>
                                                <button on:click={() => {
                                                    selectedClientId = clientId
                                                    messageModalOpen = true
                                                }} class="btn send-btn" title="Send Message">
                                                    <IconifyIcon icon={sendIcon}/>
                                                </button>
                                            </td>
                                            <td class="text-center">{totalRef}</td>
                                        </tr>
                                    {/each}
                                {/if}
                                </tbody>
                            </Table>
                            {#if $getReferralLeaderboard.hasValue}
                                <Pagination
                                    bind:currentPage={currentPageRef}
                                    totalCount={$getReferralLeaderboard.value.totalCount}
                                    perPage={perPageRef}
                                    {maxButtons}
                                    disabled={$getReferralLeaderboard.loading || $getReferralLeaderboard.loading}
                                />
                            {/if}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Weekly leaderboard</p>
                            {#if $getLeaderboardByWeek.hasValue}
                                <PerPage
                                    bind:perPage={perPageFair}
                                    disabled={$getLeaderboardByWeek.loading || $getLeaderboardByWeek.loading}
                                    totalCount={$getLeaderboardByWeek.value.totalCount}
                                />
                            {/if}
                            <Table bordered responsive>
                                <thead>
                                <tr>
                                    <td class="text-center">Place</td>
                                    <td class="text-center">User</td>
                                    <td class="text-center">Stats</td>
                                    <td class="text-center">Points</td>
                                </tr>
                                </thead>
                                <tbody>
                                {#if !$getLeaderboardByWeek.hasValue && $getLeaderboardByWeek.loading}
                                    <tr>
                                        <td class="text-center" colSpan="4">Loading...</td>
                                    </tr>
                                {:else if !$getLeaderboardByWeek.hasValue && $getLeaderboardByWeek.error }
                                    <tr>
                                        <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
                                    </tr>
                                {:else if $getLeaderboardByWeek.value}
                                    {#each $getLeaderboardByWeek.value.data as {clientId, address, totalAward, firstName, lastName, userName, stats}, i}
                                        <tr class:top-20={currentPageFair * perPageFair + i + 1 <= 10}>
                                            <td class="text-center">{currentPageFair * perPageFair + i + 1}</td>
                                            <td class="user-column">
                                                <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                    {#if userName}
                                                        @{userName}
                                                    {:else}
                                                        {firstName}{lastName ? ' '+lastName : ''}
                                                    {/if}
                                                </a>
                                                <a href="https://tonviewer.com/{address}" class="realis-logo send-btn" target="_blank" title="Wallet address">
                                                    <IconifyIcon icon={walletIcon}/>
                                                </a>
                                                <button on:click={() => {
                                                    selectedClientId = clientId
                                                    messageModalOpen = true
                                                }} class="btn send-btn" title="Send Message">
                                                    <IconifyIcon icon={sendIcon}/>
                                                </button>
                                            </td>
                                            <td title="Completed / Approved / Rejected">
                                                <span class="orange">{stats?.done}</span> /
                                                <span class="green">{stats?.approved}</span> /
                                                <span class="red">{stats?.rejected}</span>
                                            </td>
                                            <td class="text-center">{totalAward}</td>
                                        </tr>
                                    {/each}
                                {/if}
                                </tbody>
                            </Table>
                            {#if $getLeaderboardByWeek.hasValue}
                                <Pagination
                                    bind:currentPage={currentPageFair}
                                    totalCount={$getLeaderboardByWeek.value.totalCount}
                                    perPage={perPageFair}
                                    {maxButtons}
                                    disabled={$getLeaderboardByWeek.loading || $getLeaderboardByWeek.loading}
                                />
                            {/if}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Monthly leaderboard</p>
                            {#if $getLeaderboardByMonth.hasValue}
                                <PerPage
                                    bind:perPage={perPageFair}
                                    disabled={$getLeaderboardByMonth.loading || $getLeaderboardByMonth.loading}
                                    totalCount={$getLeaderboardByMonth.value.totalCount}
                                />
                            {/if}
                            <Table bordered responsive>
                                <thead>
                                <tr>
                                    <td class="text-center">Place</td>
                                    <td class="text-center">User</td>
                                    <td class="text-center">Stats</td>
                                    <td class="text-center">Points</td>
                                </tr>
                                </thead>
                                <tbody>
                                {#if !$getLeaderboardByMonth.hasValue && $getLeaderboardByMonth.loading}
                                    <tr>
                                        <td class="text-center" colSpan="4">Loading...</td>
                                    </tr>
                                {:else if !$getLeaderboardByMonth.hasValue && $getLeaderboardByMonth.error }
                                    <tr>
                                        <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
                                    </tr>
                                {:else if $getLeaderboardByMonth.value}
                                    {#each $getLeaderboardByMonth.value.data as {clientId, address, totalAward, firstName, lastName, userName, stats}, i}
                                        <tr class:top-20={currentPageFair * perPageFair + i + 1 <= 10}>
                                            <td class="text-center">{currentPageFair * perPageFair + i + 1}</td>
                                            <td class="user-column">
                                                <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                    {#if userName}
                                                        @{userName}
                                                    {:else}
                                                        {firstName}{lastName ? ' '+lastName : ''}
                                                    {/if}
                                                </a>
                                                <a href="https://tonviewer.com/{address}" class="realis-logo send-btn" target="_blank" title="Wallet address">
                                                    <IconifyIcon icon={walletIcon}/>
                                                </a>
                                                <button on:click={() => {
                                                    selectedClientId = clientId
                                                    messageModalOpen = true
                                                }} class="btn send-btn" title="Send Message">
                                                    <IconifyIcon icon={sendIcon}/>
                                                </button>
                                            </td>
                                            <td title="Completed / Approved / Rejected">
                                                <span class="orange">{stats?.done}</span> /
                                                <span class="green">{stats?.approved}</span> /
                                                <span class="red">{stats?.rejected}</span>
                                            </td>
                                            <td class="text-center">{totalAward}</td>
                                        </tr>
                                    {/each}
                                {/if}
                                </tbody>
                            </Table>
                            {#if $getLeaderboardByMonth.hasValue}
                                <Pagination
                                    bind:currentPage={currentPageFair}
                                    totalCount={$getLeaderboardByMonth.value.totalCount}
                                    perPage={perPageFair}
                                    {maxButtons}
                                    disabled={$getLeaderboardByMonth.loading || $getLeaderboardByMonth.loading}
                                />
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal bind:visible={messageModalOpen}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Send private message</div>
                <div class="modal-custom__text">
                    <label>Message:</label>
                    <textarea class="form-control" placeholder="Enter message text..." bind:value={message}></textarea>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { messageModalOpen = false }}>Close</button>
                    <button class="btn btn-primary" on:click={sendMessage} disabled={!message}>Send</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .send-btn {
        padding: 5px;
        color: #29a2da;
        line-height: 1;
        box-shadow: none;
        font-size: 18px;
    }

    .orange {
        color: #ff5d1c;
    }

    .green {
        color: #4caf50;
    }

    .red {
        color: #f44336;
    }

    .modal-custom__text {
        white-space: normal !important;
    }

    .tasks-list :global(table) {
        width: auto;
    }

    .tasks-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }

    .user-column {
        display: flex;
        align-items: center;
    }

    .top-20 td {
        background: #fff0c3;
    }

    .realis-logo {
        margin: 0 5px 0 10px;
        display: inline-block;
    }

    .realis-logo img {
        width: 20px;
    }
</style>
